/* Extensions to existing objects/javascript built-in stuff */

// Array.contains and String.contains helper methods - added directly to objects
Array.prototype.contains = function (a) {
    var b = this.length;
    while (b--) {
        if (this[b] === a) return true;
    }
    return false;
}
if (typeof String.prototype.contains === 'undefined') {
    String.prototype.contains = function (it) { return this.indexOf(it) != -1; };
}

// Return helper functions
define('core/global/helpers',["jquery", "underscore"], function($, _) {
    console.log('global/helpers');
    return {
        //************** CONVERT STRING TO FUNCTION ***********
        // get a function from the string of the function name
        // used so we can have namespaced functions defined as callbacks in string html attributes
        // e.g. <form ourCallback="some.function.name">
        getFuncFromString: function(fnName) {
            var temp, i, il, func;

            if (typeof (fnName) !== "function") {
                // split function name into pieces
                temp = fnName.split('.');
                il = temp.length;

                // loop through
                for (i = 0; i < il; i++) {
                    if (func == null) {
                        func = window[temp[i]];
                        continue;
                    }
                    func = func[temp[i]];
                }
            } else {
                func = fnName;
            }

            return func;
        },

        // takes in a string or bool value and returns a boolean
        toBool: function(val) {
            if (_.isBoolean(val)) {
                return val;
            } else if (_.isString(val)) {
                return (val.toLowerCase() === "true");
            } else {
                throw new Error("The toBool() function only works with strings and booleans.");
            }
        },

        mapKeys: function(data, map) {
            _.each(data, function(value, key, list) {
                var newKey = map[key];
                if (newKey) {
                    data[newKey] = value;
                    delete data[key];
                }
            });
            return data;
        },

        constructUrl: function(params) {
            var newurl;
            newurl = $.param(params);
            if (newurl.length > 0) {
                // Create a new query string
                newurl = '?' + newurl;
            } else {
                // Clear the query string
                newurl = document.location.pathname;
            }
            return newurl;
        },

        isMobile: function () {
            return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
        },


        validate: function (validationType, value) { //find a way to reference this without it being in the component if we care enough
            var isValid = true; //we could probably use http://caniuse.com/#feat=input-pattern instead of doing this validate method

            switch (validationType) {
                case "name":
                    if (value) { //empty value is valid
                        var nameRegex = /^[a-zA-Z \-]+$/i;
                        isValid = nameRegex.test(value);
                    }
                    break;
                case "email": //everything i've read says to let the browser do this instead of using some regex
                    if (value) { //empty value is valid
                        var emailRegex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
                        isValid = emailRegex.test(value);
                    }
                    break;
                case "phone":
                    if (value) { //empty value is valid
                        value = value.replace(/[.()-]/g, '').replace(/ /, '');
                        var phoneRegex = /^[0-9]{7,25}$/;
                        isValid = phoneRegex.test(value);
                    }
                    break;
                case "passport":
                    if (value) { //empty value is valid
                        var passportRegex = /^[\w\d]{1,12}$/;
                        isValid = passportRegex.test(value);
                    }
                    break;
                case "countryCode":
                    if (value) { //empty value is valid
                        var countryCodeRegex = /^[a-zA-Z]{3,}$/;
                        isValid = countryCodeRegex.test(value);
                    }
                    break;
                case ("date"): // Checks html5 date (YYYY-MM-DD)
                    if (value) { //empty value is valid
                        var expirationDateRegex = /^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}$/;
                        isValid = expirationDateRegex.test(value);
                    }
                    break;
                case ("dateTextInput"): // Checks date (MM/DD/YYYY)
                    if (value) { //empty value is valid
                        var expirationDateRegex = /^[0-9]{1,2}\/[0-9]{1,2}\/[0-9]{4}$/;
                        isValid = expirationDateRegex.test(value);
                    }
                    break;
            }
            return Boolean(isValid);
        },

        getCurrentDate: function () {
            var d = new Date();
            var curr_date = d.getDate();
            var curr_month = d.getMonth() + 1; //Months are zero based
            var curr_year = d.getFullYear();
            return curr_month + "/" + curr_date + "/" + curr_year;
        }
    };
});

